const drawerState = {

  CLOSED: 'closed',
  OPEN: 'open',
  MIN: 'minimized'
}

export enum DrawerState {
  CLOSED = 'closed',
  OPEN = 'open',
  MIN = 'minimized'
}

export default DrawerState
